export default "__VITE_ASSET__CMQXsv2m__"